var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: require(`@/assets/images/service/investment-research/${_vm.card.bg}`),
      expression: "require(`@/assets/images/service/investment-research/${card.bg}`)",
      arg: "background-image"
    }],
    staticClass: "scene-card"
  }, [_c("div", {
    staticClass: "scene-card__content"
  }, [_c("img", {
    attrs: {
      src: require(`@/assets/images/service/investment-research/${_vm.card.icon}`),
      alt: ""
    }
  }), _c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.card.title))]), _c("div", {
    staticClass: "desc"
  }, [_vm._v(" " + _vm._s(_vm.card.desc) + " ")])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };